import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import { displayButtons } from "../js/buttons";

export default function QuickLinks() {
    const tableRef = useRef()

    useEffect(() => {
        displayButtons(tableRef)
    }, [])
    return (
        <>
            <div id="layout-wrapper">
                <Topbar />
                <Sidebar />
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* start page title */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h2 className="fw-700 mb-sm-0">
                                            Quick Links
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            {/* end page title */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row w-100 h-100 align-items-center p-3 px-0 mx-auto">
                                                <div className="col-xl-6 col-lg-5 col-md-5">
                                                    <div className="d-md-flex text-md-start text-center align-items-center gap-3">
                                                        <div className="avatar-sm d-flex m-md-0 m-auto upcoming-icon flex-shrink-0">
                                                            <span className="avatar-title bg-primary rounded-circle fs-2">
                                                                {/* <i className="bx bx-credit-card font-size-24" /> */}
                                                                <img src="/assets/images/quick/quicklink-mt5.png" alt="" className="py-3 py-sm-0 pb-md-0" />
                                                            </span>
                                                        </div>
                                                        <h4 className="mt-md-0 mt-3 pt-md-0 pt-3 ps-3 mb-3 mb-md-0">MT5 Link</h4>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-lg-7 col-md-7">
                                                    <div className="d-flex justify-content-md-end justify-content-center flex-sm-nowrap flex-wrap gap-4">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary d-flex align-items-center"
                                                        >
                                                            <i class='bx bxl-android font-size-24 pe-1'></i>
                                                            Android
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary d-flex align-items-center"
                                                        >
                                                            <i class='bx bxl-apple font-size-24 pe-1'></i>
                                                            App Store
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary d-flex align-items-center"
                                                        >
                                                            <i class='bx bxl-windows font-size-24 pe-1'></i>
                                                            Windows
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* end col */}
                            </div>
                        </div>
                        {/* container-fluid */}
                    </div>

                    {/* End Page-content */}
                    <Footer />
                </div>
            </div>
        </>
    );
}
